import axios from "axios";
import { API_URLU }  from '../config/constant'

export default axios.create({
  baseURL: API_URLU,
  headers: {
    "Content-type": "application/json"
  }
});